// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';

// utilities
import cx from 'classnames';
import _, { get } from 'lodash';

import { getCurrent } from '../../../componentLookup';

import { stringify as queryStringify } from 'querystring';

// redux action creators for persistence
import * as asyncActionCreators from '../../../../../redux/actionCreators/async';
import { updateTempState } from '../../../../../redux/actionCreators/sync';

// components
import Toggle from 'material-ui/Toggle';
import FadeOnChange from '../../../../../common/components/c_FadeOnChange';

import { connect } from 'react-redux';
import { NavigationSubdirectoryArrowRight } from 'material-ui/svg-icons';

@connect(store => {
  return {
    viewOrder: get(store, 'labels.viewOrder', [])
  };
})
export default class Step extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    staticData: PropTypes.object.isRequired,
    activeStep: PropTypes.object.isRequired,
    activeSubStep: PropTypes.object.isRequired,
    activeSubStepIndex: PropTypes.number.isRequired,
    isLast: PropTypes.bool.isRequired,
    applicant: PropTypes.object.isRequired,
    assessments: PropTypes.object.isRequired,
    behavioralAnswers: PropTypes.object.isRequired,
    workObjectives: PropTypes.object.isRequired,
    workExperiences: PropTypes.object.isRequired,
    ratings: PropTypes.object.isRequired,
    skills: PropTypes.object.isRequired,
    licenses: PropTypes.object.isRequired,
    designations: PropTypes.object.isRequired,
    updateProgress: PropTypes.func.isRequired,
    updateTempState: PropTypes.func.isRequired,
    tempState: PropTypes.object.isRequired,
    viewState: PropTypes.object,
    applicantGroupName: PropTypes.string,
    arrayIndex: PropTypes.number,
    toggleGuide: PropTypes.func,
    guideOpen: PropTypes.bool,
    onChangeStep: PropTypes.func.isRequired,
    route: PropTypes.object.isRequired,
    viewOrder: PropTypes.array.isRequired
  }

  constructor(props, context) {
    super(props, context);
    this.state = {};
    this.state.openAccordion = null;

    this.updateTimeOut = false;

    // error count tracker
    // Is on the instance to avoid it being overwritten
    // by multiple setStates firing.
    this.errorCount = 0;

    this.updateErrorState = newCount =>
      this.setState({
        ...this.state,
        errorCount: newCount
      });

    this.errorUpdate = countChange => {
      this.errorCount += countChange;
      this.updateErrorState(this.errorCount);
    };
  }

  saveData() {


    const currentComponent = getCurrent(this.props.activeStep.key, this.props.activeSubStep.key);
    const newState = _.cloneDeep(this.props.tempState);
    _.set(newState, 'user.id', this.props.applicant.user.id);
    _.set(newState, 'profile.id', this.props.applicant.profile.id);
    _.set(newState, `profile.viewState.progress.admin.application.${this.props.activeStep.key}.${this.props.activeSubStep.key}.done`, currentComponent.validator());
    if (newState.profile.viewState) {
      newState.profile.viewState = _.merge({}, {
        progress: { admin: { application: this.props.viewState } }
      }, this.props.applicant.profile.viewState, newState.profile.viewState);
    }

    // update back end
    let actions = (currentComponent.saveFunc || asyncActionCreators.updateApplicantAdmin)(newState, this.props.applicantGroupName, this.props.arrayIndex);
    actions = (_.isArray(actions)) ? actions : [actions];
    actions.map(action => this.props.dispatch(action));
  }

  // Directly saved from local state.
  saveStateData(newState) {


    const currentComponent = getCurrent(this.props.activeStep.key, this.props.activeSubStep.key);
    _.set(newState, 'user.id', this.props.applicant.user.id);
    _.set(newState, 'profile.id', this.props.applicant.profile.id);
    _.set(newState, `profile.viewState.progress.admin.application.${this.props.activeStep.key}.${this.props.activeSubStep.key}.done`, currentComponent.validator());
    if (newState.profile.viewState) {
      newState.profile.viewState = _.merge({}, {
        progress: { admin: { application: this.props.viewState } }
      }, this.props.applicant.profile.viewState, newState.profile.viewState);
    }

    // update back end
    let actions = (currentComponent.saveFunc || asyncActionCreators.updateApplicantAdmin)(newState, this.props.applicantGroupName, this.props.arrayIndex);
    actions = (_.isArray(actions)) ? actions : [actions];
    actions.map(action => this.props.dispatch(action));
  }

  onSave() {

    this.saveData();

    // clearing temp state after save
    this.props.dispatch(updateTempState({}));

    this.toggleOpenAccordion('save');
  }

  openInWindow(step, substep) {
    const basePath = `/admin/${this.props.route.params.navColumnState}/${this.props.route.params.email}`;
    const queryString = `?${queryStringify({ detail: 1, openInWindow: 1 })}`;
    if (window) {
      const win = window.open(`${basePath}/${step}/${substep}${queryString}`, 'openInWindow', 'width=900,height=450,location=no,menubar=no');
      win.focus();
    }
  }

  toggleScripts(step, substep, toggled) {
    this.props.updateTempState('profile', `viewState.progress.admin.application.${step}.${substep}.scriptVisible`, null, toggled);
  }

  toggleOpenAccordion(substep) {

    this.setState({
      openAccordion: substep
    });

    const routeCategory = this.props.route.params.category;
    const routeSubCategory = this.props.route.params.subcategory;
    const activeStepIndex = _.findIndex(this.props.viewOrder, o => o.key === routeCategory);
    const basePath = `/admin/${this.props.route.params.navColumnState}/${this.props.route.params.email}`;
    const queryString = `?${queryStringify(this.props.route.query)}`;

    const categoryLength = this.props.viewOrder[_.findIndex(this.props.viewOrder, ['key', routeCategory])].subNav.length;
    const currentStepIndex = _.findIndex(this.props.viewOrder[
      _.findIndex(this.props.viewOrder, ['key', routeCategory])
    ].subNav, ['key', routeSubCategory]);

    if (substep !== 'save') {
      this.props.onChangeStep(activeStepIndex, `${basePath}/${routeCategory}/${substep}${queryString}`);
    }
    else {
      if (currentStepIndex + 1 < categoryLength) {
        this.props.onChangeStep(activeStepIndex,
          `${basePath}/${routeCategory}/${this.props.viewOrder[activeStepIndex].subNav[currentStepIndex + 1].key}${queryString}`);
      } else {
        this.props.onChangeStep(activeStepIndex, `${basePath}/${routeCategory}/${queryString}`);

        /* if(!this.props.viewOrder[_.findIndex(this.props.viewOrder, ['display', routeCategory] )+1]){
           this.props.onChangeStep(3, `${basePath}/references${queryString}`)
         }else{
           this.props.onChangeStep(activeStepIndex, `${basePath}/${this.props.viewOrder[activeStepIndex+1].display}/${this.props.viewOrder[activeStepIndex+1].subNav[0].key}${queryString}`)
         }*/
      }
    }
  }

  // wrapper for update temp state method call
  localUpdateTempState(...params) {
    const _this = this;
    // depounce a bit save request
    if (!this.updateTimeOut) {
      this.updateTimeOut = true;
      setTimeout(() => {
        _this.saveData();
        _this.updateTimeOut = false;
      }, 1);
    }

    // update tempstate object, based on what will be sent update data
    this.props.updateTempState(...params);
  }

  render() {
    const {
      component,
      saveFunc,  // eslint-disable-line no-unused-vars
      ...stepProps
    } = getCurrent(this.props.activeStep.key, this.props.activeSubStep.key);


    const localViewState = (this.props.viewState[this.props.activeStep.key] || {})[this.props.activeSubStep.key] || {};
    const expanded = this.props.route.params.subcategory === this.props.activeSubStep.key;
    const done = localViewState.done;
    const script = this.props.activeSubStep.script;
    const scriptVisible = _.get(this.props.tempState, `profile.viewState.progress.admin.application.${this.props.activeStep.key}.${this.props.activeSubStep.key}.scriptVisible`, true);
    const showSaveOrNext = expanded &&
      (this.props.activeSubStep.showNext || this.props.tempState[stepProps.model]);

    const actionText = !showSaveOrNext ? 'View' : this.props.activeSubStep.showNext && !this.props.isLast ? 'Next' : 'Save';
    const openInWindow = this.props.route.query.openInWindow === '1';

    return (
      <div
        className={cx('accordion-item', { expanded })}
        key={this.props.activeSubStepIndex}
        id={`step${this.props.activeSubStepIndex}`}
      >
        <div
          className={cx('accordion-heading', { clickable: !expanded })}
          data-id={this.props.activeSubStep.display}
          onClick={!expanded && this.toggleOpenAccordion.bind(this, this.props.activeSubStep.key)}
        >
          <div
            className='left'
            onClick={!openInWindow && expanded && this.toggleOpenAccordion.bind(this, 'test2')}
          >
            <div className={cx('checkbox', { checkmark: done })} />
            <div className='accordion-text noTextSelect'>
              {this.props.activeSubStep.display}
            </div>
          </div>
          <div className='right'>
            <div className={cx('script-toggle', 'noTextSelect', { showScriptToggle: expanded && script })}>
              Script
                <Toggle
                className='script-toggle-icon'
                data-id='Script'
                disabled={this.props.activeSubStep.display === 'Conclusion to the Interview'}
                disableTouchRipple
                disableFocusRipple
                labelPosition='right'
                toggled={script && scriptVisible}
                onToggle={this.toggleScripts.bind(this, this.props.activeStep.key, this.props.activeSubStep.key, !scriptVisible)}
                style={{ transition: 'none' }}
                elementStyle={{ transition: 'none' }}
                trackStyle={{ height: '8px', transition: 'background-color .2s cubic-bezier(0.23, 1, 0.32, 1)' }}
                thumbStyle={{ top: '-2px', transition: 'background-color .2s cubic-bezier(0.23, 1, 0.32, 1), left .2s cubic-bezier(0.23, 1, 0.32, 1), margin .2s cubic-bezier(0.23, 1, 0.32, 1)' }}
              />
              <div className='script-state-text'>
                <FadeOnChange
                  duration={195}
                  className='noTextSelect'
                >
                  {script && scriptVisible ? 'On' : 'Off'}
                </FadeOnChange>
              </div>
            </div>
            <div className={cx('script-toggle', 'noTextSelect', 'open-window', { showScriptToggle: expanded && this.props.activeSubStep.openInWindow })}
              onClick={this.openInWindow.bind(this, this.props.activeStep.key, this.props.activeSubStep.key)}
            >
              Open In Window
              </div>
            <div
              className='accordion-toggle'
              data-id={actionText}
            >
              <div
                className={cx('accordion-toggle-text', 'noTextSelect', { clickable: showSaveOrNext })}
                onClick={
                  showSaveOrNext && !this.errorCount ?
                    this.onSave.bind(this)
                    :
                    this.toggleOpenAccordion.bind(this, 'save')
                }
              >
                {actionText}
              </div>
              <div
                className='accordion-caret-container'
                onClick={expanded && this.toggleOpenAccordion.bind(this, 'test')}
              >
                <div
                  className={cx('accordion-toggle-caret', 'chevron', { toggled: expanded })}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className='expanded-accordion admin-view'
          style={{
            maxHeight: expanded ? 'none' : 0,
            display: expanded ? '' : 'none'
          }}
        >
          {
            component({
              adminView: true,
              staticData: this.props.staticData,
              applicant: this.props.applicant,
              behavioralAnswers: this.props.behavioralAnswers,
              workObjectives: this.props.workObjectives,
              workExperiences: this.props.workExperiences,
              ratings: this.props.ratings,
              skills: this.props.skills,
              licenses: this.props.licenses,
              designations: this.props.designations,
              profile: this.props.applicant.profile,
              tempState: this.props.tempState,
              updateTempState: this.localUpdateTempState.bind(this),
              errorUpdate: this.errorUpdate,
              script: script && scriptVisible,
              assessments: this.props.assessments,
              dispatch: this.props.dispatch,
              saveData: this.saveStateData.bind(this),
              ...stepProps
            })
          }
        </div>
      </div>
    );

  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/c_Steps/c_Step/index.js